// Base URL for your backend
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_KEY = process.env.REACT_APP_API_KEY;

// Endpoints
export const CONTACT_ENDPOINT = "/contact.php";
export const CAREER_ENDPOINT = "/career.php";

// Footer info
export const FOOTER_INFO = {
  copyright: "© 2026 Giraffic Info World. All Rights Reserved.",
  designedBy: "Giraffic Info World",
  designedByUrl: "https://www.girafficinfoworld.com",
};
